import { Card, CardContent } from "@/components/ui/card";

const IntegrationsSection = () => {
  const integrations = [
    "Go High-Level",
    "Google Calendar/Meet",
    "Microsoft 365",
    "Zoom",
    "Stripe",
    "Twilio",
    "Meta Inbox",
    "WhatsApp Business",
    "Slack",
    "Webhooks",
    "Google Sheets/Drive"
  ];

  return (
    <section className="py-16 space-y-8">
      <div className="text-center space-y-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground">
          Seamless Integrations
        </h2>
        <p className="text-muted-foreground text-base max-w-2xl mx-auto">
          Connect with the tools you already use
        </p>
      </div>

      <Card className="border-border">
        <CardContent className="p-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {integrations.map((integration, index) => (
              <div 
                key={index}
                className="px-4 py-2 bg-primary/10 text-foreground rounded-full text-sm font-medium hover:bg-primary/20 transition-colors"
              >
                {integration}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default IntegrationsSection;
